import { CustomerEnquirySearchCriteria } from "presentation/constant/CustomerEnquiry/CustomerEnquirySearchCriteria";
import { useCustomerEnquiryVM } from "presentation/hook/CustomerEnquiry/useCustomerEnquiryVM";
import { useCustomerEnquiryTracked } from "presentation/store/CustomerEnquiry/CustomerEnquiryProvider";
import { useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import CustomerEnquirySearchForm from "./CustomerEnquirySearchForm";

const CompanySearchPanel = () => {
    const customerEnquiryVM = useCustomerEnquiryVM();
    const [customerEnquiryState] = useCustomerEnquiryTracked();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const resetButtonClicked = useCallback(() => {
        customerEnquiryVM.onRemoveAllSearchCriteria();
    }, [customerEnquiryVM]);

    const searchButtonClicked = useCallback((criteria: CustomerEnquirySearchCriteria) => {
        setIsLoading(true);
        customerEnquiryVM.onSearch(criteria).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, [customerEnquiryVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{'Search Criteria'}</SidebarTitle>

                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={customerEnquiryVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        {/* Stack Form Start */}
                        <CustomerEnquirySearchForm />
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(customerEnquiryState.searchCriteria)} />
            </SidebarActionBar>
        </div>
    );
}

export default CompanySearchPanel;
